export default __webpack_public_path__ + "701315d6301ec78faa4ba19048cad0ae.png";